module.exports = __webpack_public_path__ + "img/loginback.31443b78.jpg";